import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/terminal-velocity-calculator',
  component: () => import('../../routes/TerminalVelocityCalculator.svelte'),
  card: {
    id: 'terminal-velocity-calculator',
    title: 'Terminal Velocity',
    description: 'Compute the steady falling speed of any object in any fluid using v = √(2mg / ρACd). Presets for skydiver, raindrop, baseball, and parachute.',
    icon: 'south',
    iconBgClass: 'bg-sky-50',
    iconTextClass: 'text-sky-600',
    href: '/terminal-velocity-calculator',
    category: 'Physics & Science',
  },
  seo: {
    title: 'Terminal Velocity Calculator – Free Falling Speed Solver',
    description: 'Calculate the terminal velocity of any falling object. Uses v = √(2mg / ρACd). Includes presets for skydiver, parachutist, baseball, raindrop, hailstone, and ping-pong ball. Shows result in m/s, km/h, mph, and ft/s.',
  },
};

export default meta;
